import { Component, inject } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import {
  TableLazyLoadEvent,
  TableModule,
  TableRowSelectEvent,
} from 'primeng/table';
import { KunderService } from '@features/kunder/kunder.service';
import { CprNummerPipe } from '@core/pipes/cprnummer.pipe';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';

@Component({
  selector: 'app-kunde-result',
  imports: [
    TableRowDirective,
    TableModule,
    CprNummerPipe,
    KeepScrollPositionDirective,
  ],
  templateUrl: './kunde-result.component.html',
  styleUrl: './kunde-result.component.css',
})
export class KundeResultComponent {
  kundeService = inject(KunderService);
  data = this.kundeService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.kundeService.selectKundeResultRow(e.data);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    this.kundeService.datasource.loadData(
      event.sortField,
      event.sortOrder === -1,
      event.first
    );
  }
}
